import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import amxLogo from "@/assets/amx-logo-light.svg";

const HeroAlt = () => {
  return (
    <section className="min-h-screen flex items-center justify-center px-4 py-20 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="space-y-12">
          {/* Brand */}
          <div className="space-y-6">
            <img src={amxLogo} alt="AMX Ventures" className="h-20 md:h-32 w-auto" />
          </div>

          {/* Main message */}
          <div className="space-y-8 max-w-3xl">
            <div className="inline-block px-6 py-3 bg-accent/10 border-2 border-accent/20 rounded">
              <span className="text-sm font-bold tracking-[0.3em] text-accent uppercase">
                AI Infrastructure · Sovereign AI · Physical AI
              </span>
            </div>

            <h1 className="text-4xl md:text-6xl font-black leading-relaxed">
              <span className="text-primary whitespace-nowrap">Capital builds the product.</span>
              <br />
              <span className="text-primary whitespace-nowrap">Distribution wins the market.</span>
              <br />
              <span className="bg-gradient-to-r from-accent to-accent/70 bg-clip-text text-transparent whitespace-nowrap">
                We bring both.
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed max-w-5xl border-l-4 border-accent pl-6">
              AMX Ventures is an early-stage venture capital fund backing founders building{" "}
              <span className="font-bold text-primary">AI infrastructure, sovereign &amp; physical AI</span>. Then we put
              them in front of buyers: hyperscaler co-sell, enterprise introductions, and an operating partner who has
              closed the kind of deals you're chasing.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                size="lg" 
                variant="default" 
                className="text-lg h-14 px-10 font-bold"
                asChild
              >
                <a href="mailto:arun@amx.ventures">
                  Pitch AMX
                  <ArrowRight className="ml-2" />
                </a>
              </Button>
              <Button size="lg" variant="outline" className="text-lg h-14 px-10 font-bold border-2" asChild>
                <a href="#portfolio">
                  See the portfolio
                </a>
              </Button>
            </div>
          </div>

          {/* Proof bar */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 pt-12">
            <div className="p-8 bg-secondary border-l-4 border-accent">
              <div className="text-5xl font-black text-accent mb-2">3</div>
              <p className="text-sm font-bold uppercase tracking-wider text-foreground">Companies Exited</p>
            </div>
            <div className="p-8 bg-secondary border-l-4 border-primary">
              <div className="text-5xl font-black text-primary mb-2">21</div>
              <p className="text-sm font-bold uppercase tracking-wider text-foreground">Years In Enterprise Deal Rooms</p>
            </div>
            <div className="p-8 bg-secondary border-l-4 border-accent">
              <div className="text-5xl font-black text-accent mb-2">50+</div>
              <p className="text-sm font-bold uppercase tracking-wider text-foreground">Enterprise Accounts</p>
            </div>
            <div className="p-8 bg-secondary border-l-4 border-primary">
              <div className="text-2xl font-black text-primary mb-2">Microsoft · AWS · GCP</div>
              <p className="text-sm font-bold uppercase tracking-wider text-foreground">Co-sell · US ↔ GCC</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroAlt;
